<template>
  <Modal v-model:isOpen="isOpen" modalId="add-new-order-modal" maxWidth="7xl" :isClosableOnEsc="false" @close="onClose">
    <template #title>New Order</template>
    <template #content>
    <div class="uk-background-muted">
        <div
          v-if="createdOrder"
          class="uk-dark uk-background-muted uk-container"
        >
          <div class="uk-alert-primary uk-text-secondary">
            <h3>Created Order {{ createdOrder.id }}</h3>
            <b>Drop-Off: {{ createdOrder.receiver.name }}</b>
            <br />
            <b>Bill To : {{ createdOrder.billTo.name }}</b>
            <br />
            <table class="uk-table uk-table-divider">
              <thead>
                <th>Container Number</th>
                <th>Size/Type</th>
                <th>Terminal</th>
              </thead>
              <tbody>
                <tr
                  v-for="(container, containerIdx) in createdOrder.containers"
                  v-bind:key="`fetched-container-${containerIdx}`"
                >
                  <td v-if="container.containerId != 'EXPUNDEF'">
                    {{ container.containerId }}
                  </td>
                  <td v-else>Container Number not defined</td>
                  <td>{{ container.sizeType }}</td>
                  <td>{{ container.terminal }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else class="uk-dark uk-background-muted uk-container">
          <!-- <div class="uk-flex uk-flex-center uk-flex-rows uk-flex-wrap"> -->

          <h2>New Order</h2>
          <div
            uk-switcher="animation: uk-animation-fade; toggle: > *; connect: .container-switcher"
          >
            <button
              class="uk-button switcher uk-button-default"
              type="button"
              @click="setOrderType(ORDER_TYPE.OCEAN_IMPORT)"
            >
              <WikisIcon> </WikisIcon>
              Ocean
            </button>
            <button
              class="uk-button switcher uk-button-default"
              type="button"
              @click="setOrderType(ORDER_TYPE.RAIL_PICK_UP)"
            >
              <TrainIcon> </TrainIcon>
              Rail
            </button>
            <button
              class="uk-button switcher uk-button-default"
              type="button"
              @click="setOrderType(ORDER_TYPE.LAND)"
            >
              <DeliveryTruck> </DeliveryTruck>
              Land
            </button>
          </div>
          <div class="uk-align-center uk-margin-top">
            <div class="uk-flex uk-flex-center">
              <ul
                class="uk-subnav uk-subnav-pill uk-margin-remove-bottom"
                uk-switcher="connect: .switcher-container"
                v-if="isOceanOrder"
              >
                <li @click="setOrderType(ORDER_TYPE.OCEAN_IMPORT)">
                  <a href="#">Import</a>
                </li>
                <li @click="setOrderType(ORDER_TYPE.OCEAN_EXPORT)">
                  <a href="#">Export</a>
                </li>
              </ul>
              <ul
                class="uk-subnav uk-subnav-pill uk-margin-remove-bottom"
                uk-switcher="connect: .switcher-container"
                v-if="isRailOrder"
              >
                <li @click="setOrderType(ORDER_TYPE.RAIL_PICK_UP)">
                  <a href="#">Rail Pick-Up</a>
                </li>
                <li @click="setOrderType(ORDER_TYPE.RAIL_DELIVERY)">
                  <a href="#">Rail Delivery</a>
                </li>
              </ul>
              <ul
                class="uk-subnav uk-subnav-pill uk-margin-remove-bottom"
                uk-switcher="connect: .switcher-container"
                v-if="isLandOrder"
              >
                <li @click="setOrderType(ORDER_TYPE.LAND)">
                  <a href="#">Land Order</a>
                </li>
              </ul>
            </div>

            <ul
              class="uk-switcher switcher-container uk-margin"
              v-if="isOceanOrder"
            >
              <li>
                <AddNewOrderForm
                  @onBillingCustomerSearch="onBillingCustomerSearch"
                  @onReceivingCustomerSearch="onReceivingCustomerSearch"
                  :billingCustomers="billingCustomers"
                  :receivingCustomers="receivingCustomers"
                  :activeBLs="activeBLs"
                  :orderData="orderData"
                  :orderType="ORDER_TYPE.OCEAN_IMPORT"
                  :activeContainersWithoutOrder="activeContainersWithoutOrder"
                  :settingsOrderShowLinkedOrderNumberField="
                    company && company.settingsOrderShowLinkedOrderNumberField
                  "
                  :showVesselInformation="
                    company && company.settingsOrderShowVesselInformation
                  "
                  :settingsOrderShowEmergencyInformation="
                    company && company.settingsOrderShowEmergencyInformation
                  "
                  :settingsOrderLtlEnabled="
                    company && company.settingsOrderLtlEnabled
                  "
                  :showBrokerFields="company && company.isBroker"
                ></AddNewOrderForm>
              </li>
              <li>
                <AddNewOrderForm
                  @onBillingCustomerSearch="onBillingCustomerSearch"
                  @onReceivingCustomerSearch="onReceivingCustomerSearch"
                  :billingCustomers="billingCustomers"
                  :receivingCustomers="receivingCustomers"
                  :activeBLs="activeBLs"
                  :orderData="orderData"
                  :orderType="ORDER_TYPE.OCEAN_EXPORT"
                  :activeContainersWithoutOrder="activeContainersWithoutOrder"
                  :showVesselInformation="
                    company && company.settingsOrderShowVesselInformation
                  "
                  :settingsOrderLtlEnabled="
                    company && company.settingsOrderLtlEnabled
                  "
                  :settingsOrderShowEmergencyInformation="
                    company && company.settingsOrderShowEmergencyInformation
                  "
                  :showBrokerFields="company && company.isBroker"
                ></AddNewOrderForm>
              </li>
            </ul>
            <ul
              class="uk-switcher switcher-container uk-margin"
              v-if="isRailOrder"
            >
              <li>
                <AddNewOrderForm
                  @onBillingCustomerSearch="onBillingCustomerSearch"
                  @onReceivingCustomerSearch="onReceivingCustomerSearch"
                  :billingCustomers="billingCustomers"
                  :receivingCustomers="receivingCustomers"
                  :activeBLs="activeBLs"
                  :orderData="orderData"
                  :orderType="ORDER_TYPE.RAIL_PICK_UP"
                  :activeContainersWithoutOrder="activeContainersWithoutOrder"
                  :settingsOrderShowLinkedOrderNumberField="
                    company && company.settingsOrderShowLinkedOrderNumberField
                  "
                  :showVesselInformation="
                    company && company.settingsOrderShowVesselInformation
                  "
                  :settingsOrderShowEmergencyInformation="
                    company && company.settingsOrderShowEmergencyInformation
                  "
                  :settingsOrderLtlEnabled="
                    company && company.settingsOrderLtlEnabled
                  "
                  :showBrokerFields="company && company.isBroker"
                ></AddNewOrderForm>
              </li>
              <li>
                <AddNewOrderForm
                  @onBillingCustomerSearch="onBillingCustomerSearch"
                  @onReceivingCustomerSearch="onReceivingCustomerSearch"
                  :billingCustomers="billingCustomers"
                  :receivingCustomers="receivingCustomers"
                  :activeBLs="activeBLs"
                  :orderData="orderData"
                  :orderType="ORDER_TYPE.RAIL_DELIVERY"
                  :activeContainersWithoutOrder="activeContainersWithoutOrder"
                  :showVesselInformation="
                    company && company.settingsOrderShowVesselInformation
                  "
                  :settingsOrderShowEmergencyInformation="
                    company && company.settingsOrderShowEmergencyInformation
                  "
                  :settingsOrderLtlEnabled="
                    company && company.settingsOrderLtlEnabled
                  "
                  :showBrokerFields="company && company.isBroker"
                ></AddNewOrderForm>
              </li>
            </ul>
            <ul
              class="uk-switcher switcher-container uk-margin"
              v-if="isLandOrder"
            >
              <li>
                <AddNewOrderForm
                  @onBillingCustomerSearch="onBillingCustomerSearch"
                  @onReceivingCustomerSearch="onReceivingCustomerSearch"
                  :billingCustomers="billingCustomers"
                  :receivingCustomers="receivingCustomers"
                  :activeBLs="activeBLs"
                  :orderData="orderData"
                  :orderType="ORDER_TYPE.LAND"
                  :activeContainersWithoutOrder="activeContainersWithoutOrder"
                  :settingsOrderShowLinkedOrderNumberField="
                    company && company.settingsOrderShowLinkedOrderNumberField
                  "
                  :showVesselInformation="
                    company && company.settingsOrderShowVesselInformation
                  "
                  :settingsOrderShowEmergencyInformation="
                    company && company.settingsOrderShowEmergencyInformation
                  "
                  :settingsOrderLtlEnabled="
                    company && company.settingsOrderLtlEnabled
                  "
                  :showBrokerFields="company && company.isBroker"
                ></AddNewOrderForm>
              </li>
            </ul>
          </div>

          <div
            class="uk-flex-inline uk-flex-column uk-text-left uk-margin-right"
          >
            <!-- Need to do this so that button is same height as input fields, so this makes a label with whitespace -->
            <label class="uk-form-label">{{ '\xa0' }}</label>
            <button
              class="uk-button uk-button-primary uk-form-controls"
              v-on:click="addNewOrder"
            >
              <span class="uk-margin-right" v-if="loading" uk-spinner></span>
              {{ orderCreationButtonText }}
            </button>
            <div v-if="validationError" class="uk-form-danger uk-text-center">
              <p>{{ validationError }}</p>
            </div>
          </div>
        </div>
    </div>
    </template>
  </Modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import Modal from '@/components/core/Modal/Modal.vue';

import activeContainersWithoutOrderQuery from '@/gql/orders/queries/ActiveContainersWithoutOrderQuery.gql';
import ActiveBLs from '@/gql/orders/ActiveBLs.gql';
import TerminalsQuery from '@/gql/terminals/Terminals.gql';

import TrainIcon from '@carbon/icons-vue/es/train/24';
import WikisIcon from '@carbon/icons-vue/es/wikis/24';
import DeliveryTruck from '@carbon/icons-vue/es/delivery-truck/24';

import AddDeliveryOrder from '@/gql/orders/mutations/AddDeliveryOrder.gql';
import { blExistsInActiveBls, findActiveBl } from '@/utils/active_BLs_apollo';

import 'vue-datepicker-next/index.css';

import { SteamShipLinesMap } from '../../utils/constants';

import { showGraphQLError } from '../../utils/data_extraction';
import CompanyQuery from '../../gql/company/Company.gql';
import CustomerQuery from '../../gql/customers/Customer.gql';
import BillingCustomersQuery from '../../gql/customers/BillingCustomers.gql';
import ReceivingCustomersQuery from '../../gql/customers/ReceivingCustomers.gql';

import isContainer from '../../utils/container_validator';
import AddNewOrderForm from './NewOrders/AddNewOrderForm.vue';

import { addressMixin } from '../../utils/address';
import { dateFormatMixin } from '../../utils/date';
import { orderTypeMixin } from '../../utils/order';

import { ORDER_TYPE } from '../../types';

import {
  addOrderDataShipline,
  addTerminalToOrderData,
  preparePayloadForMutation,
} from './NewOrders/orderData';

export default defineComponent({
  name: 'AddNewOrderModal',
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    queryBillOfLading: String,
    queryCustomerId: String,
  },
  emits: ['close', 'addNewOrder'],
  mixins: [addressMixin, dateFormatMixin, orderTypeMixin],
  components: {
    Modal,
    AddNewOrderForm,
    TrainIcon,
    WikisIcon,
    DeliveryTruck,
  },
  data() {
    return {
      createdOrder: undefined,
      company: null as any,
      billingCustomerNameQuery: '',
      receivingCustomerNameQuery: '',
      isExistingBL: false,
      loading: false,
      isAddingNewDropoff: false,
      isAddingNewBillTo: false,
      ORDER_TYPE,

      validationError: '',
      orderType: ORDER_TYPE.OCEAN_IMPORT,

      orderData: {
        orderType: ORDER_TYPE.OCEAN_IMPORT,
        isDropAndHook: false,
        billOfLadingNumber: undefined,
        bookingNumber: undefined,
        customerReference: undefined,
        billingCustomerReference: undefined,
        linkedMasterOrderNumber: undefined,
        pickUpLocation: undefined,
        dropOffLocation: undefined,
        dropOffContact: {
          name: undefined,
          phoneNumber: undefined,
          email: undefined,
        },
        billTo: undefined,
        billToContact: {
          name: undefined,
          phoneNumber: undefined,
          email: undefined,
        },
        shipLineInfo: {
          line: undefined,
          vessel: undefined,
          eta: undefined,
        },
        brokerSailingInfo: {
          portOfLoading: undefined,
          portOfDischarge: undefined,
          placeOfReceipt: undefined,
          placeOfDelivery: undefined,
          vesselVoyage: undefined,
          sailingDate: undefined,
          arrivalDate: undefined,
        },
        containers: [],
        carrierName: undefined,
        scacCode: undefined,
        emergencyResponsePhoneNumber: undefined,
        houseBillOfLading: undefined,
      },
    };
  },

  computed: {
    isOpen: {
      get(): boolean {
        return (this as any).open;
      },
      set(value: boolean) {
        if (!value) {
          (this as any).onClose();
        }
      },
    },
    orderCreationButtonText(): string {
      const vm = (this as any);

      switch (vm.orderData.orderType) {
        default: {
          return 'Create Order';
        }
      }
    },
    doesBLExist(): boolean {
      const vm = (this as any);
      return blExistsInActiveBls(vm.activeBLs, vm.orderData.billOfLadingNumber);
    },
    mappedBLs(): any[] {
      const vm = (this as any);

      if (!vm.activeBLs) {
        return [];
      }
      return vm.activeBLs.map((x) => `${x.billOfLadingId}`);
    },
    shouldShowContainers(): boolean {
      return true;
    },
    isImportOrder(): boolean {
      return (this as any).orderData.orderType === ORDER_TYPE.OCEAN_IMPORT;
    },
    containerNumbersValid(): boolean {
      const vm = (this as any);

      if (vm.orderData.containers.length > 0) {
        return vm.orderData.containers.reduce((acc, x) => {
          if (!acc) return false;

          if (!x.containerId) {
            return true;
          }

          if (!isContainer(x.containerId)) return false;

          return true;
        }, true);
      } else {
        return true;
      }
    },
    orderFormValid(): boolean {
      const vm = (this as any);

      if (vm.orderData) {
        if (!vm.orderData.pickUpLocation) {
          return false;
        }

        if (!vm.orderData.dropOffLocation.name) {
          return false;
        }

        if (!vm.orderData.billTo.name) {
          return false;
        }

        return true;
      }
      return true;
    },
    activeBLs(): any[] {
      const vm = (this as any);

      if (!vm.activeBls) {
        return [];
      }
      return vm.activeBls.filter(
        (x) => x.deliveryOrders.length === 0,
      );
    },
  },
  watch: {
    queryBillOfLading: {
      immediate: true,
      handler(val) {
        const vm = (this as any);

        if (vm.queryBillOfLading) {
          // Find BL for  container
          const mappedBls2 = vm.activeBLs.map((x: any) => {
            return x.id;
          });
          console.log(mappedBls2);
          const foundBlIdx = mappedBls2.indexOf(val);

          if (foundBlIdx > -1) {
            const foundBl: any = vm.activeBLs[foundBlIdx];
            console.log(foundBl.billOfLadingId);
            vm.orderData.billOfLadingNumber = foundBl.billOfLadingId;
            vm.selectBL(foundBl.billOfLadingId);
          }
        }
      },
    },
  },

  methods: {
    onClose() {
      const vm = (this as any);

      if (
        vm.$router.currentRoute.path.includes('/orders') &&
        (vm.$router.currentRoute.path !== '/orders/' ||
          vm.$route.query.billOfLading)
      ) {
        vm.$router.replace('/orders/').catch((err) => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err);
          }
        });
      }

      vm.createdOrder = undefined;
      vm.billingCustomerNameQuery = '';
      vm.receivingCustomerNameQuery = '';
      vm.isAddingNewDropoff = false;
      vm.isAddingNewBillTo = false;

      vm.$emit('close');
    },
    setOrderType(orderType) {
      const vm = (this as any);

      vm.orderType = orderType;
      vm.setOrderDataType(orderType);
    },
    setOrderDataType(orderType) {
      (this as any).orderData.orderType = orderType;
    },
    selectBL(val) {
      const vm = (this as any);

      const activeBl = findActiveBl(vm.activeBLs, val);
      if (activeBl) {

        console.log(
          `Selected BL ${val} ${JSON.stringify(
            activeBl,
          )} user Bls is ${JSON.stringify(vm.activeBLs)}`,
        );

        const containers = activeBl.containers.slice();
        (vm.orderData as any).containers = containers.map((x) => {
          const { id, ...dat } = x;

          dat.freightContents = dat.freightContents.map((y) => {
            return {
              quantity: y.cargoPieces,
              packingType: y.packingType,
              isHazmat: y.isHazmat,
              weight: y.weight,
              description: y.cargoDescription,
              nmfcNumber: y.nmfcNumber,
              nmfcClass: y.nmfcClass,
            };
          });
          return dat;
        });

        if (vm.terminals) {
          console.log('adding to term data');
          addTerminalToOrderData(
            activeBl.pickUpLocation,
            vm.terminals,
            vm.orderData,
          );
        }
        if (activeBl.latestVessel) {
          vm.orderData.shipLineInfo.vessel = activeBl.latestVessel.name;
        }
        addOrderDataShipline(val, vm.orderData);
      }
    },
    validateFields(): boolean {
      const vm = (this as any);

      if (vm.isImportOrder) {
        if (!vm.orderData.pickUpLocation) {
          vm.validationError = 'Specify pick-up location';
          return false;
        }

        if (!vm.orderData.dropOffLocation.name) {
          vm.validationError = 'Specify drop-off location';
          return false;
        }

        if (!vm.orderData.billTo.name) {
          vm.validationError = 'Specify bill-to';
          return false;
        }

        if (!vm.validateContainerNumberValid()) {
          vm.validationError =
            'Your container number is not valid. Please check it.';
          return false;
        }

        return true;
      } else if (vm.orderData.orderType === ORDER_TYPE.OCEAN_EXPORT) {
        if (!vm.orderData.bookingNumber) {
          vm.validationError = 'Specify Booking Number';
          return false;
        }
      }
      return true;
    },
    validateContainerNumberValid(): boolean {
      const vm = (this as any);

      if (vm.orderData.containers.length > 0) {
        return vm.orderData.containers.reduce((acc, x) => {
          if (!acc) return false;

          if (!x.containerId) {
            return true;
          }

          if (!isContainer(x.containerId)) return false;

          return true;
        }, true);
      } else {
        return true;
      }
    },
    changedETA(dateStr: string) {
      const vm = (this as any);

      const parsedDate = (this as any).formatDate(dateStr);
      vm.orderData.shipLineInfo.eta = parsedDate;
    },
    resetFormData() {
      const vm = (this as any);

      vm.orderData = {
        orderType: ORDER_TYPE.OCEAN_IMPORT,
        isDropAndHook: false,
        billOfLadingNumber: undefined,
        bookingNumber: undefined,
        customerReference: undefined,
        billingCustomerReference: undefined,
        linkedMasterOrderNumber: undefined,
        pickUpLocation: undefined,
        dropOffLocation: undefined,
        dropOffContact: {
          name: undefined,
          phoneNumber: undefined,
          email: undefined,
        },
        brokerSailingInfo: {
          portOfLoading: undefined,
          portOfDischarge: undefined,
          placeOfReceipt: undefined,
          placeOfDelivery: undefined,
          vesselVoyage: undefined,
          sailingDate: undefined,
          arrivalDate: undefined,
        },
        billTo: undefined,
        billToContact: {
          name: undefined,
          phoneNumber: undefined,
          email: undefined,
        },
        shipLineInfo: {
          line: undefined,
          vessel: undefined,
          eta: '',
        },
        containers: [],
        carrierName: undefined,
        scacCode: undefined,
        emergencyResponsePhoneNumber: undefined,
        houseBillOfLading: undefined,
      };
    },
    toggleImport() {
      (this as any).orderData.orderType = ORDER_TYPE.OCEAN_IMPORT;
    },
    toggleExport() {
      (this as any).orderData.orderType = ORDER_TYPE.OCEAN_EXPORT;
    },
    toggleDropPick() {
      (this as any).orderData.orderType = ORDER_TYPE.DROP_PICK;
    },
    removeContainer(containerIdx: number) {
      console.log('removing container');
      (this as any).orderData.containers.splice(containerIdx, 1);
    },
    addContainer() {
      const vm = (this as any);

      console.log('adding container');
      vm.orderData.containers.push({
        containerId: undefined,
        size: undefined,
        type: undefined,
        sealNumber: undefined,
        isAdded: true,
      });
    },
    onReceivingCustomerSearch(customerName) {
      (this as any).receivingCustomerNameQuery = customerName;
    },
    onBillingCustomerSearch(customerName) {
      (this as any).billingCustomerNameQuery = customerName;
    },
    setReceivingCustomer(customer) {
      const vm = (this as any);

      console.log(`setting receiving customer ${JSON.stringify(customer)}`);
      if (customer.id) {
        vm.orderData.dropOffLocation.name = customer.name;
        const address = customer.deliveryAddress;
        vm.orderData.dropOffLocation.streetAddress = address.streetAddress;
        vm.orderData.dropOffLocation.suite = address.suite;
        vm.orderData.dropOffLocation.city = address.city;
        vm.orderData.dropOffLocation.state = address.state;
        vm.orderData.dropOffLocation.zipCode = address.zipCode;
        vm.isAddingNewDropoff = false;
      } else {
        vm.orderData.dropOffLocation.name = customer.name;
        vm.isAddingNewDropoff = true;
      }
    },
    setBillingCustomer(customer) {
      const vm = (this as any);

      console.log(`setting billing customer ${JSON.stringify(customer)}`);
      if (customer.id) {
        vm.orderData.billTo.name = customer.name;
        const address = customer.billingAddress;
        vm.orderData.billTo.streetAddress = address.streetAddress;
        vm.orderData.billTo.suite = address.suite;
        vm.orderData.billTo.city = address.city;
        vm.orderData.billTo.state = address.state;
        vm.orderData.billTo.zipCode = address.zipCode;
        vm.isAddingNewBillTo = false;
      } else {
        vm.orderData.billTo.name = customer.name;
        vm.isAddingNewBillTo = true;
      }
    },

    addNewOrder() {
      const vm = (this as any);

      vm.loading = true;
      if (!vm.validateFields()) {
        vm.loading = false;
        return;
      }

      const payload = preparePayloadForMutation(
        vm.orderData,
        vm.isImportOrder,
      );

      vm.$apollo
        .mutate({
          mutation: AddDeliveryOrder,
          variables: payload,
        })
        .then((result) => {
          vm.loading = false;
          vm.newOrderCustomer = undefined;
          vm.billOfLading = undefined;
          vm.isAddingNewOrder = false;
          console.log('added new order');
          const element = document.getElementById('AddNewOrderModal');

          const order = result.data.addDeliveryOrder.order;
          const containers = result.data.addDeliveryOrder.orderContainers;

          vm.resetFormData();
          vm.createdOrder = order;
          vm.validationError = '';
          vm.$emit('addNewOrder', order.id);
        })
        .catch((err) => {
          console.error(err);
          vm.loading = false;
          vm.validationError = showGraphQLError(err);
          vm.newOrderCustomer = undefined;
          vm.billOfLading = undefined;
          vm.isAddingNewOrder = false;
        });
    },
  },
  ...{
    apollo: {
      company: {
        query: CompanyQuery,
      },
      activeBls: {
        query: ActiveBLs,
        fetchPolicy: 'cache-and-network',
      },
      billingCustomers: {
        query: BillingCustomersQuery,
        debounce: 100,
        variables() {
          return {
            name: (this as any).billingCustomerNameQuery,
          };
        },
      },
      receivingCustomers: {
        query: ReceivingCustomersQuery,
        debounce: 100,
        variables() {
          return {
            name: (this as any).receivingCustomerNameQuery,
          };
        },
      },
      activeContainersWithoutOrder: {
        query: activeContainersWithoutOrderQuery,
      },
      terminals: {
        query: TerminalsQuery,
      },
      queryCustomer: {
        query: CustomerQuery,
        variables() {
          return {
            id: (this as any).queryCustomerId,
          };
        },
        result(data, error) {
          if (data) {
            if (data.data.customer) {
              (this as any).setReceivingCustomer(data.data.customer);
            }
          }
        },
      },
    },
  },
});
</script>

<style lang="scss" scoped>
</style>
